export default {
  data: {
    skip_pjax_destroy: true,
    global_mode: true,
    nav_items: [
      {
        icon_class: 'kf-dashboard',
        label: 'Change Me',
        is_active: true,
        callback: () => console.log('Change Me!')
      }
    ]
  },

  watch: {
    global_mode() {
      setTimeout(Kadenze.LeftNav.init, 300);
    }
  },

  mounted() {
    Kadenze.LeftNav.init();

    this.$bus.$on('left_nav_render', (config) => {
      this.global_mode = false;
      this.nav_items = config.nav_items;
    });

    this.$bus.$on('left_nav_update', (config) => {
      this.global_mode = false;
      _.each(config.nav_items, function (item, index) {
        _.extend(this.nav_items[index], item);
      });
    });

    this.$bus.$on('left_nav_clear', () => {
      this.global_mode = true;
      this.nav_items = [];
    });
  }
};

